import { render, staticRenderFns } from "./transferHeader.vue?vue&type=template&id=fbcf82ac&scoped=true"
import script from "./transferHeader.vue?vue&type=script&lang=js"
export * from "./transferHeader.vue?vue&type=script&lang=js"
import style0 from "./transferHeader.vue?vue&type=style&index=0&id=fbcf82ac&prod&lang=less&scoped=true"
import style1 from "./transferHeader.vue?vue&type=style&index=1&id=fbcf82ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcf82ac",
  null
  
)

export default component.exports